import { routes } from "@constants/routes";
import { PageWrapper } from "@cpj-ai/panel-npm-package";
import { useGetJobPositionByIdQuery } from "@graphql/generated";
import { Card } from "@heroui/react";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TechnicalInformation from "../../../components/TechnicalInformation";
import GeneralInformationAndActions from "./GeneralInformationAndActions";
import PositionDetailAndCompanyDetail from "./PositionDetailAndCompanyDetail";

const JobPositionPreviewContent = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const { data: jobPositionData, refetch } = useGetJobPositionByIdQuery({
    variables: {
      id: id || "",
    },
  });

  const handleBackToEdit = () => {
    navigate(`${routes.jobPositions.edit}?id=${id}`);
  };

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <PageWrapper title="Job Post Preview" className="py-7 px-5 w-full" showBackButton onBack={handleBackToEdit}>
      <PositionDetailAndCompanyDetail />
      <div className="flex flex-col md:flex-row gap-6 mt-4">
        <Card className="w-full md:w-8/12 py-6 px-4 h-fit" shadow="sm">
          <TechnicalInformation jobPositionData={jobPositionData} />
        </Card>
        <GeneralInformationAndActions handleBackToEdit={handleBackToEdit} jobPositionData={jobPositionData} />
      </div>
    </PageWrapper>
  );
};
export default JobPositionPreviewContent;
